<div class="container-fluid">

  <!-- Step 1: Template + Job Type + Location -->
  <nz-card nzTitle="Job Submission">
    <nz-row [nzGutter]="24">
      <nz-col [nzSpan]="12">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon>Template Job</nz-form-label>
          <nz-select style="width: 100%" [(ngModel)]="templateJob" nzShowSearch nzAllowClear
            nzPlaceHolder="Select a job to use as template">
            @for (job of projectJobs(); track job.id) {
            <nz-option [nzValue]="job" [nzLabel]="job.name"></nz-option>
            }
          </nz-select>
        </nz-form-item>
      </nz-col>

      <nz-col [nzSpan]="12">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon>Job Type</nz-form-label>
          <nz-select style="width: 100%" [ngModel]="selectedJobType()" (ngModelChange)="selectedJobType.set($event)"
            [nzDisabled]="true" nzAllowClear nzPlaceHolder="Select job type">
            @for (opt of jobTypeOptions; track opt.value) {
            <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            }
          </nz-select>
        </nz-form-item>
      </nz-col>

      <nz-col [nzSpan]="24">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon nzRequired>Job Location</nz-form-label>
          <nz-form-control
            [nzValidateStatus]="(jobPathTouched() && !jobPath().trim()) || jobPathHasSpaces() ? 'error' : ''"
            [nzErrorTip]="jobPathHasSpaces() ? 'Job location cannot contain spaces' : 'Job location is required'">
            <input nz-input [ngModel]="jobPath()" (ngModelChange)="jobPath.set($event)"
              (blur)="jobPathTouched.set(true)" placeholder="/path/to/new/job" />
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>
  </nz-card>

  <app-job-config
    [job]="templateJob()"
    [jobPath]="jobPath()"
    (configChange)="jobConfigValues.set($event)"
    (validityChange)="jobConfigValid.set($event)" />

  @if (templateJob() && selectedJobType()) {
    <app-file-assignment
      [loading]="jobTemplateResource.isLoading()"
      [fileSpecs]="currentFileSpecs()"
      [allFiles]="allFiles()"
      [runfiles]="runfiles()"
      [jobs]="projectJobs() ?? []"
      [templateJob]="templateJob()"
      [defaultBasePath]="templateFilesBasePath()"
      [xwiPrefix]="xwiPrefixForFiles()"
      (resolvedSelectionsChange)="resolvedSelections.set($event)"
      (resolvedRenamesChange)="resolvedRenames.set($event)">
    </app-file-assignment>
  }

  <app-file-editor style="display: block; margin-top: 15px"
    [job]="templateJob()"
    [runfile]="resolvedSelections()['runfile'] ?? null"
    [(editedRunfileContent)]="editedRunfileContent"
    [(editedEnvShContent)]="editedEnvShContent">
  </app-file-editor>

  <div class="submit-row">
    <button nz-button [disabled]="!canSubmit() || prepping()" [nzLoading]="prepping()" (click)="prep()" style="margin-right: 8px;">
      <span nz-icon nzType="tool" nzTheme="outline"></span>
      Prep Job
    </button>
    <!-- <button nz-button nzType="primary" [disabled]="!canSubmit() || submitting()" [nzLoading]="submitting()" (click)="submit()">
      <span nz-icon nzType="rocket" nzTheme="outline"></span>
      Submit Job
    </button> -->
  </div>

</div>

<ng-template #confirmSubmitTpl>
  <div class="confirm-details">
    <div class="confirm-row">
      <span class="confirm-label">Project</span>
      <span class="confirm-value">{{ currentProject()?.name }}</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-label">New Job Path</span>
      <code class="confirm-value confirm-value--mono">{{ jobPath() }}</code>
    </div>
    <div class="confirm-row">
      <span class="confirm-label">Template Job</span>
      <span class="confirm-value">{{ templateJob()?.name }}</span>
    </div>
    <div class="confirm-row">
      <span class="confirm-label">Job Config Name</span>
      <input
        nz-input
        class="confirm-value"
        [ngModel]="jobConfigValues()?.['job_name']"
        (ngModelChange)="updateJobConfigName($event)" />
    </div>
    <div class="confirm-row">
      <span class="confirm-label">Files Selected</span>
      <span class="confirm-value">{{ (resolvedSelections() | keyvalue)?.length ?? 0 }} file(s)</span>
    </div>
    @if (runfileLintIssues().length || envShLintIssues().length) {
      <div class="confirm-row">
        <span class="confirm-label">Warnings</span>
        <span class="confirm-value confirm-value--warning">
          @if (runfileLintIssues().length) {
            {{ runfileLintIssues().length }} possible issue(s) in the runfile.
          }
          @if (envShLintIssues().length) {
            {{ envShLintIssues().length }} possible issue(s) in env.sh.
          }
          Check the File Editor tabs before continuing.
        </span>
      </div>
    }
  </div>
</ng-template>
